import { CurrentUser } from "../models/CurrentUser";

export class WebStorageService {
  constructor(){

  }

  public setJson(key:string, value:any, persistence: Persistence = Persistence.UnlessCleared) {
    
    switch (persistence) {
      //Remember me checkbox is not CHECKED
      case Persistence.UnlessClosed:
        //removes old user from localstorage
        localStorage.removeItem(key);
        sessionStorage.setItem(key, JSON.stringify(value));
        break;

      //Remember me checkbox is CHECKED
      case Persistence.UnlessCleared:
        //removes old user from sessionStorage
        sessionStorage.removeItem(key);

        let user:CurrentUser = value as CurrentUser;
        //localstorage has no expiry, this is a workaround.
        user.Expiry = Date.now() + 2592000000;
        // localStorage.setItem(key, JSON.stringify(value));
        localStorage.setItem(key, JSON.stringify(user));
        break;

      default:
        throw new Error("Invalid persistence.");
    }
  }

  public getJson(key:string):any {
    let value = sessionStorage.getItem(key);

    if(value != null)
    {
      return JSON.parse(value);
    } else {
      value = localStorage.getItem(key);
      
      if(value != null){
        return JSON.parse(value);
      }
    }

    return null;
  }

  // public set(key:string, value:any) {
  //   localStorage.setItem(key, value);
  // }

  public get(key:string) {
    return localStorage.getItem(key);
  }
 
  /**
   * Removes the specified key and value from both localStorage and sessionStorage
   * @param key is the localStorage OR sessionStorage key
   */
  public remove(key:string) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  public clear() {
    localStorage.clear();
    sessionStorage.clear();
  }
}

/**
 * In UnlessClosed, the data is cleared when window or tab is closed.
 * In UnlessCleared, the data is cleared when the user clears his browsers/web history is cleared. 
 */
export enum Persistence {
  UnlessClosed = 1,
  UnlessCleared = 2
}